import { StaticQuery, graphql } from "gatsby";
import React from "react";

import {
  Section,
  Image,
  Card,
  Header2,
  Underlined,
  Paragraph,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Hero";
import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

export const HappyCustomers = () => (
  <Section
    css={`
      @media screen and (min-width: ${getSize("tablet720")}) {
        justify-content: flex-end;
      }
    `}
  >
    <StaticQuery
      query={graphql`
        query HappyCustomersHeroImageQuery {
          file(relativePath: { eq: "HappyCustomer.png" }) {
            ...HeroImage
          }
        }
      `}
      render={({ file }) => (
        <Image
          alt=""
          css={`
            + picture > img,
            img {
              object-position: 70% 50%;
              @media screen and (min-width: ${getSize("tablet720")}) {
                object-position: 50% 50%;
              }
            }
          `}
          file={file}
        />
      )}
    />
    <Card
      css={`
        @media screen and (min-width: ${getSize("desktop1920")}) {
          width: 571px;
        }
      `}
    >
      <Header2>
        {"Happy Customers"}
        <Underlined />
      </Header2>
      <Paragraph>
        {
          "Flexible Load Management offers utility operators predictable, flexible, dispatchable loads, with virtually no interruption to consumers’ daily routines. Non-invasive load reductions avoid the need for end-user interaction, thereby reducing the instances of consumer opt-out."
        }
      </Paragraph>
    </Card>
  </Section>
);
